import { observer } from 'mobx-react';
import * as style from './TextMessage.module.less';
import { SideChatMessage } from '@assets/model/SideChatStore';
import FlLogo from '../FlightlineChatLogo.svg';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { MarkdownContent } from '@assets/component/UI/MarkdownContent/MarkdownContent';
import { convertMarkdown } from '@assets/utils/Utils';
import { formatDivMarkup } from '@assets/utils/CompUtils';

interface TextMessageMessageProps {
    message: SideChatMessage;
}

const TextMessage = observer((p: TextMessageMessageProps) => {
    const { message: m } = p;

    const dangerousHtml = convertMarkdown(m.content);
    const content = formatDivMarkup(m.content, style.contentBase);
    // Buggy
    //(
    //     <MarkdownContent className={style.contentBase} html={dangerousHtml} />
    //     <
    // );

    return (
        <Flex>
            <div className={style.logoBackgroundBase}>
                <img src={FlLogo}></img>
            </div>

            {content}
        </Flex>
    );
});

export default TextMessage;
